import type { PublicApiKey } from '@/apilib';
import type { createBiApi } from './api';

export const BiApiKey: PublicApiKey<typeof createBiApi> = {
  name: 'BiApi',
  public: true,
};
